//
// AbstractDataItem.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "../expressions/DataTypeExt";
import "../../models/data/dataset/DataUsage";

var AbstractDataItem = createModule("commons::AbstractDataItem", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getStringValue: [7,1],
        getName: [7],
        getLabel: [7],
        getNumericValue: [6,1],
        isValid: [2],
        getDataType: [4],
        isWildcard: [2],
        isMeasure: [2],
        getUsage: [7],
        isCurrent: [2],
        getDataUsage: [4],
        isNumeric: [2,1],
        clone: [1],
        getFormat: [7],
        isValidForContext: [2,1],
    },
    ,
    ,
]);
export default AbstractDataItem;
